import { useMemo, useCallback } from 'react';
// import useUAParser from 'hooks/useUAParser';
import { useSelector } from 'react-redux';
import { selectTenant } from 'state/tenant';

type FinancingWalletButtonHook = () => () => {
  hasAppleButton: boolean;
  hasGoogleButton: boolean;
  hasFinancingWalletButton: boolean;
};

const useFinancingWalletButton: FinancingWalletButtonHook = () => {
  const {
    enabledFeatures: { financingWallet },
  } = useSelector(selectTenant);

  const wallets = financingWallet
    ? financingWallet.wallets
      ? financingWallet.wallets
      : []
    : [];

  const hasAppleButton = useMemo(() => {
    return wallets.includes('Apple_Pay');
  }, [wallets]);

  const hasGoogleButton = useMemo(() => {
    return wallets.includes('Google_Pay');
  }, [wallets]);

  const hasFinancingWalletButton = hasAppleButton || hasGoogleButton;

  return useCallback(
    () => ({
      hasAppleButton,
      hasGoogleButton,
      hasFinancingWalletButton,
    }),
    [hasAppleButton, hasFinancingWalletButton, hasGoogleButton],
  );
};

export default useFinancingWalletButton;
